import { createContext, useContext, useState, useEffect } from 'react';

const SelectedCompanyContext = createContext({});

export function SelectedCompanyProvider({ children }) {
  const [selectedCompanyId, setSelectedCompanyId] = useState(() => {
    // Carregar empresa selecionada do localStorage
    const saved = localStorage.getItem('selectedCompanyId');
    return saved ? parseInt(saved) : null;
  });

  const selectCompany = (companyId) => {
    setSelectedCompanyId(companyId);
    if (companyId) {
      localStorage.setItem('selectedCompanyId', companyId.toString());
    } else {
      localStorage.removeItem('selectedCompanyId');
    }
  };

  const clearSelection = () => {
    setSelectedCompanyId(null);
    localStorage.removeItem('selectedCompanyId');
  };

  return (
    <SelectedCompanyContext.Provider value={{ selectedCompanyId, selectCompany, clearSelection }}>
      {children}
    </SelectedCompanyContext.Provider>
  );
}

export function useSelectedCompany() {
  const context = useContext(SelectedCompanyContext);
  if (!context) {
    throw new Error('useSelectedCompany deve ser usado dentro de um SelectedCompanyProvider');
  }
  return context;
}

export default SelectedCompanyContext;

